import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import ImportExport from '@material-ui/icons/ImportExport';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import styled from 'styled-components';

const CustomPaper = styled(Paper)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const CustomFormControl = styled(FormControl)`
  width: 90%;
`;
/**
 * Composant permettant de selectionner les options d'export de commande
 * @param {Object} values       valeur des paramêtres à utiliser pour l'export
 * @param {Function} handleChange handleChange
 * @param {Function} handleClick  handleClick
 */
const ExportOptions = ({ values, handleChange, handleClick }) => (
  <CustomPaper>
    <CustomFormControl component="fieldset">
      <FormLabel component="legend">Filtrer par</FormLabel>
      <RadioGroup
        aria-label="FilterBy"
        name="filterBy"
        value={values.filterBy}
        onChange={({ target: { value } }) => handleChange(value, 'filterBy')}
      >
        <FormControlLabel
          value="byCreation"
          control={<Radio color="primary" />}
          label="Date de création"
        />
        <FormControlLabel
          value="byExpedition"
          control={<Radio color="primary" />}
          label="Date d'expédition"
        />
      </RadioGroup>
    </CustomFormControl>

    <CustomFormControl component="fieldset">
      <FormLabel component="legend">Type</FormLabel>
      <RadioGroup
        name="sentByMe"
        value={values.sentByMe}
        onChange={({ target: { value } }) => handleChange(value, 'sentByMe')}
      >
        <FormControlLabel
          value="1"
          control={<Radio color="primary" />}
          label="Expéditions"
        />
        <FormControlLabel
          value="0"
          control={<Radio color="primary" />}
          label="Réceptions"
        />
      </RadioGroup>
    </CustomFormControl>

    <CustomFormControl component="fieldset">
      <FormLabel component="legend">Format</FormLabel>
      <RadioGroup
        name="format"
        onChange={({ target: { value } }) => handleChange(value, 'format')}
        value={values.format}
      >
        <FormControlLabel
          value="excel"
          control={<Radio color="primary" />}
          label="Excel"
        />
        <FormControlLabel
          value="csv"
          control={<Radio color="primary" />}
          label="CSV"
        />
      </RadioGroup>
    </CustomFormControl>
    <Button color="primary" variant="contained" onClick={handleClick}>
      EXPORTER
      <ImportExport />
    </Button>
  </CustomPaper>
);

ExportOptions.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default ExportOptions;
